export const generateTableHead = () => [
  { title: 'ID', access: true, class: 'p-l' },
  { title: 'Bonus', access: true, class: 'p-l' },
  { title: 'Method', access: true },
  { title: 'From', access: true },
  { title: 'Status', access: true },
  { title: '', access: true, attrs: { style: { width: '1%' } } },
].filter((item) => item.access);

export const generateTableBody = (item) => [
  { type: 'id', value: item.id, class: 'p-l', access: true },
  { type: 'bonus', value: item.bonus, class: 'p-l', access: true },
  { type: 'method', value: item.method_name, access: true },
  { type: 'from', value: item.deposit_from, access: true },
  { type: 'status', value: item.status_name, access: true },
  { type: 'actions', value: null, class: 'p-r', access: true },
].filter((item) => item.access);
